import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { FaEdit, FaTrash, FaToggleOn, FaToggleOff } from "react-icons/fa";
import PropTypes from "prop-types";
import "./BannerCard.css";

function BannerCard({ banner, onEdit, onDelete, onToggleActive }) {
  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-IE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Card className="banner-card">
      <Card.Header className="banner-card-header">
        <div className="banner-card-title-section">
          <h5 className="banner-card-type">{banner.banner_type}</h5>
          <Badge bg={banner.is_active ? "success" : "secondary"} className="banner-card-badge">
            {banner.is_active ? "Active" : "Inactive"}
          </Badge>
        </div>
      </Card.Header>

      <Card.Body className="banner-card-body">
        <div className="banner-card-content">
          <p className="banner-card-header-text">
            <strong>{banner.header}</strong>
          </p>
          {banner.subheader && (
            <p className="banner-card-subheader">{banner.subheader}</p>
          )}
        </div>

        <div className="banner-card-metadata">
          {banner.countryid && (
            <p className="banner-meta-item">
              <strong>Country:</strong> {banner.countryid}
            </p>
          )}
          {banner.schoolid && (
            <p className="banner-meta-item">
              <strong>School:</strong> {banner.schoolid}
            </p>
          )}
          <p className="banner-meta-item">
            <strong>Created:</strong> {formatDate(banner.created_at)}
          </p>
          <p className="banner-meta-item">
            <strong>Updated:</strong> {formatDate(banner.updated_at)}
          </p>
        </div>

        <div className="banner-card-actions">
          <Button
            size="sm"
            variant="info"
            onClick={() => onEdit(banner)}
            className="banner-action-btn"
            title="Edit"
          >
            <FaEdit /> Edit
          </Button>

          <Button
            size="sm"
            variant={banner.is_active ? "warning" : "success"}
            onClick={() => onToggleActive(banner)}
            className="banner-action-btn"
            title={banner.is_active ? "Deactivate" : "Activate"}
          >
            {banner.is_active ? <FaToggleOn /> : <FaToggleOff />}
            {banner.is_active ? "Deactivate" : "Activate"}
          </Button>

          <Button
            size="sm"
            variant="danger"
            onClick={() => onDelete(banner.id)}
            className="banner-action-btn"
            title="Delete"
          >
            <FaTrash /> Delete
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

BannerCard.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.string,
    banner_type: PropTypes.string.isRequired,
    countryid: PropTypes.string,
    schoolid: PropTypes.string,
    header: PropTypes.string.isRequired,
    subheader: PropTypes.string,
    is_active: PropTypes.bool,
    created_at: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    updated_at: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onToggleActive: PropTypes.func.isRequired,
};

export default BannerCard;